export default __webpack_public_path__ + "arrow-right-4ca3eea6763f94892f5b5c8ffbc1ad16.svg";